export const extractFieldForceCreateErrorMessages = (errors) => {
  const messages = [];

  const recurse = (value) => {
    if (Array.isArray(value)) value.forEach(recurse);
    else if (typeof value === "object" && value !== null)
      Object.values(value).forEach(recurse);
    else if (typeof value === "string" && value.trim()) messages.push(value);
  };

  recurse(errors);
  return messages;
};

/** Always returns a string safe for toast / React children. */
export const toSafeErrorMessage = (value, fallback = "Something went wrong") => {
  if (typeof value === "string" && value.trim()) return value;
  if (Array.isArray(value)) {
    const first = value.find((item) => typeof item === "string" && item.trim());
    if (first) return first;
  }
  if (value && typeof value === "object") {
    const nested = extractFieldForceCreateErrorMessages(value);
    if (nested.length > 0) return nested[0];
  }
  return fallback;
};

export const persistFieldForceCreateError = (error) => {
  const raw =
    typeof error === "string"
      ? error
      : error?.errors || error?.error || error;

  const messages = extractFieldForceCreateErrorMessages(raw);
  const errorState =
    messages.length > 0
      ? messages
      : [toSafeErrorMessage(raw, "An unknown error occurred")];

  try {
    sessionStorage.setItem(
      "fieldForceAccountCreateError",
      JSON.stringify(errorState),
    );
  } catch {
    // Ignore storage failures and still return the error state.
  }

  return errorState;
};

export const readFieldForceCreateError = (locationState) => {
  if (locationState) return locationState;

  try {
    const stored = sessionStorage.getItem("fieldForceAccountCreateError");
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

export const buildSwitchFieldForceEditPayload = ({
  bene_acc_id,
  updatedPayload,
  navigate,
}) => ({
  id: bene_acc_id,
  name: updatedPayload?.account_name ?? updatedPayload?.name ?? "",
  email: updatedPayload?.email_id,
  linked_user_id: updatedPayload?.linked_user_id || null,
  type_of_account: "field_force",
  navigate,
});
